import { __read } from "tslib";
var unpackMessage = function (messageCompressed, playerCreationTime, packages) {
    var _a = __read(messageCompressed, 7), type = _a[0], relativeTimestamp = _a[1], packageIndex = _a[2], featureNumber = _a[3], messageId = _a[4], args = _a[5], pinLifetime = _a[6];
    var packageNamespace = packages[packageIndex].namespace;
    return [
        type,
        relativeTimestamp + playerCreationTime,
        packageNamespace,
        featureNumber,
        messageId,
        args,
        pinLifetime,
    ];
};
var unpackMessageHistory = function (compressedMessageHistoryShards) {
    if (compressedMessageHistoryShards.length > 1) {
        // NB: Sharding is not currently implemented so we expect a single payload only
        throw new RangeError('Unpacking of multiple sharded payloads is not currently implemented');
    }
    var _a = __read(compressedMessageHistoryShards, 1), firstShardedPayload = _a[0];
    var messagesCompressed = firstShardedPayload.m, packageListCompressed = firstShardedPayload.p, playerCreationTime = firstShardedPayload.u;
    var packages = packageListCompressed.map(function (_a) {
        var _b = __read(_a, 2), namespace = _b[0], version = _b[1];
        return ({
            namespace: namespace,
            version: version,
        });
    });
    return {
        messages: messagesCompressed.map(function (messageCompressed) {
            return unpackMessage(messageCompressed, playerCreationTime, packages);
        }),
        packages: packages,
        playerCreationTime: playerCreationTime,
    };
};
export { unpackMessageHistory, unpackMessage };
//# sourceMappingURL=unpackMessageHistory.js.map